export default "__VITE_ASSET__Br9ZqvIX__"